import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from '../../form/select-group';
import ToggleGroup from '../../form/toggle-group';

class Component extends BaseComponent {
    componentDidMount() {
        this.genders = {
            female: 'FEMALE',
            male: 'MALE',
            na: 'NONE OF YOUR BUSINESS',
        };

        this.relationships = {
            'Married': 'Married',
            'In a Relationship': 'In a Relationship',
            'Dating': 'Dating',
            'Single not looking': 'Single Not Looking',
            'Single and happy that way!': 'Single and Happy That Way!',
            'Open to anything': 'Open to Anything',
        };

        this.orientations = {
            'Straight': 'STRAIGHT',
            'Gay': 'GAY',
            'Bisexual': 'BI-SEXUAL',
            'None of your business': 'NONE OF YOUR BUSINESS',
        };
    }

    render() {
        return (
            <more-about-you>
                <row className='is-wrap'>
                    <column className='is-12'>
                        <label>Gender</label>
                        <ToggleGroup
                            options={this.genders}
                            value={this.props.user.sex ? this.props.user.sex : 'na'}
                            name='gender'
                            onChange={this.handleChange}
                        />
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            label='Relationship Status'
                            name='relationship_status'
                            value={this.props.user.relationship_status}
                            placeholder='SELECT YOUR RELATIONSHIP STATUS'
                            options={this.relationships}
                            onChange={this.handleChange}
                        />
                    </column>
                    <column className='is-12'>
                        <label>Sexual Orientation</label>
                        <ToggleGroup
                            options={this.orientations}
                            value={this.props.user.sexual_orientation}
                            name='sexual_orientation'
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            </more-about-you>
        );
    }

    handleChange = (e) => {
        const name = e.target.name == 'gender' ? 'sex' : e.target.name;
        this.props.userUpdate({ [name]: e.target.value });
        this.props.onChange(e.target.name, e.target.value);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
